export default __webpack_public_path__ + "static/bg1-c05d73caf4f20b64a83e899fe53b1a13.png";